export default {
  key: "account_service_plan",
  id: "asp_id",
  action: ["create","edit"],
  fields: [
    { key: "asp_id" },
    { key: "start_date", type: "date" },
    { key: "end_date", type: "date" },
    { key: "plan_total" },
    { key: "acc_id", type: "select", field: "acc_id.first_name", value: "acc_id.acc_id", },
    { key: "cp_id", type: "select", field: "cp_id.cp_no", value: "cp_id.cp_id", },
    { type: "action-btn" }
    // { key: "plan_id", type: "select", field: "plan_id.name", value: "plan_id.plan_id", },
  ],
  filters: {
    acc_id: {
      type: "multiselect",
      label: "name",
      value: "acc_id",
      filterable: true
    },
    cp_id: {
      type: "multiselect",
      label: "cp_no",
      value: "cp_id",
      filterable: true
    }
  },
  options: {
    acc_id: {
      key: "accounts",
      label: "first_name",
      value: "acc_id"
    },
    cp_id: {
      key: "cps",
      label: "cp_no",
      value: "cp_id"
    }
  },
  structure: [
    ["start_date","end_date"],
    ["plan_total"],
    ["acc_id","cp_id"]
  ],
}